// Les pages d'impression (CER, avenant, pass orientation) masquent la coquille
// (menu latéral et barre haute) le temps de leur affichage. La classe est
// posée sur <body> et lue par menu-lateral.scss ; la fonction renvoie le
// rétablissement, à retourner depuis l'effet qui l'a appelée.
export const CLASSE_COQUILLE_MASQUEE = "coquille-masquee";

export function masquerCoquille() {
  document.body.classList.add(CLASSE_COQUILLE_MASQUEE);
  return () => document.body.classList.remove(CLASSE_COQUILLE_MASQUEE);
}
